// extracted by mini-css-extract-plugin
export default {"message":"delete-workstream-modal_message__VP8py","actions":"delete-workstream-modal_actions__HLOws"};